export const getUserProfileRoute = user => {
  return `/${user.username}`
}
